<ion-grid class="health-page ion-padding-horizontal ion-padding-bottom">

  <!-- Loading spinner -->
  <ion-row *ngIf="loading && !error" class="ion-justify-content-center ion-align-items-center ion-padding-vertical">
    <ion-spinner name="circular"></ion-spinner>
  </ion-row>

  <!-- Error message -->
  <ion-row *ngIf="error" class="ion-justify-content-center">
    <ion-col size="12">
      <ion-item color="warning" lines="none">
        <ion-icon name="alert-circle" slot="start"></ion-icon>
        <ion-label>
          {{ error }}
        </ion-label>
      </ion-item>

      <ion-card class="health-card health-visual-card">
        <ion-card-header>
          <ion-card-subtitle>Preview</ion-card-subtitle>
          <ion-card-title>Kiln Health Visual (Example Data)</ion-card-title>
        </ion-card-header>
        <ion-card-content class="health-visual-card-content">
          <div class="health-visual-frame">
            <app-kiln-health-visual
              [zoneStates]="['critical', 'warning', 'good']"
              controllerState="critical"
              clockState="warning"
              outletState="good">
            </app-kiln-health-visual>
          </div>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>

  <ng-container *ngIf="!loading && !error">
    <!-- Small: stacked (visual then accordion). Large (lg+): 50% / 50% columns -->
    <ion-row class="health-split-row ion-align-items-start">
      <ion-col size="12" size-lg="6" class="health-visual-col-wrap">
        <ion-card class="health-card health-visual-card">
          <ion-card-header>
            <ion-card-title>Kiln health</ion-card-title>
          </ion-card-header>
          <ion-card-content class="health-visual-card-content ion-padding-horizontal">
            <div class="health-visual-frame">
              <app-kiln-health-visual
                [zoneStates]="zoneStates"
                [controllerState]="controllerState"
                [clockState]="clockState"
                [outletState]="outletState">
              </app-kiln-health-visual>
            </div>
            <dl class="health-mini-legend ion-hide-lg-up">
              <div><dt>Zones</dt><dd>{{ zoneStates.join(', ') }}</dd></div>
              <div><dt>Controller</dt><dd>{{ controllerState }}</dd></div>
              <div><dt>Supply</dt><dd>{{ outletState }}</dd></div>
            </dl>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col size="12" size-lg="6" class="health-accordion-col-wrap">
        <ion-card class="health-card health-accordion-card">
          <ion-accordion-group [multiple]="false" value="checks">
            <ion-accordion value="checks">
              <ion-item slot="header" lines="full">
                <ion-label>System checks</ion-label>
              </ion-item>
              <div slot="content">
                <ion-list lines="full" class="ion-no-margin">
                  <ion-item>
                    <ion-icon [name]="diagnostics.wireSizeOk ? 'checkmark-circle' : 'alert-circle'"
                              [color]="diagnostics.wireSizeOk ? 'success' : 'danger'"
                              slot="start">
                    </ion-icon>
                    <ion-label class="ion-text-wrap">
                      Wire size adequate
                      <ion-icon
                        name="information-circle-outline"
                        color="medium"
                        class="info-icon"
                        (click)="presentWireSizeInfo($event)">
                      </ion-icon>
                      <p>{{ diagnostics.wireSizeOk ? 'OK' : 'Check required' }}</p>
                    </ion-label>
                  </ion-item>

                  <ion-item>
                    <ion-icon [name]="diagnostics.allZonesEnergizing ? 'checkmark-circle' : 'alert-circle'"
                              [color]="diagnostics.allZonesEnergizing ? 'success' : 'danger'"
                              slot="start">
                    </ion-icon>
                    <ion-label class="ion-text-wrap">
                      All zones energizing
                      <ion-icon
                        name="information-circle-outline"
                        color="medium"
                        class="info-icon"
                        (click)="presentAllZonesInfo($event)">
                      </ion-icon>
                      <p>{{ diagnostics.allZonesEnergizing ? 'Yes' : 'No' }}</p>
                      <p *ngIf="!diagnostics.allZonesEnergizing">Non-energized zones: {{ diagnostics.nonEnergizedZones }}</p>
                    </ion-label>
                  </ion-item>

                  <ion-item>
                    <ion-icon [name]="diagnostics.controllerOutputsOk ? 'checkmark-circle' : 'alert-circle'"
                              [color]="diagnostics.controllerOutputsOk ? 'success' : 'danger'"
                              slot="start">
                    </ion-icon>
                    <ion-label class="ion-text-wrap">
                      Controller outputs powering
                      <ion-icon
                        name="information-circle-outline"
                        color="medium"
                        class="info-icon"
                        (click)="presentControllerOutputsInfo($event)">
                      </ion-icon>
                      <p>{{ diagnostics.controllerOutputsOk ? 'OK' : 'Check required' }}</p>
                      <p *ngIf="!diagnostics.controllerOutputsOk">Outputs to review: {{ diagnostics.lowPowerOutputs }}</p>
                    </ion-label>
                  </ion-item>
                </ion-list>
              </div>
            </ion-accordion>

            <ion-accordion value="specs">
              <ion-item slot="header" lines="full">
                <ion-label>Factory specs vs. current</ion-label>
              </ion-item>
              <div slot="content" class="ion-padding">
                <ion-item *ngIf="!allElementsHeating" color="warning" lines="none" class="health-warning-banner">
                  <ion-icon name="warning" slot="start"></ion-icon>
                  <ion-label class="ion-text-wrap">Not all elements are heating</ion-label>
                </ion-item>

                <ion-grid class="specs-grid ion-no-padding ion-margin-top">
                  <ion-row class="specs-header-row">
                    <ion-col></ion-col>
                    <ion-col class="ion-text-center">Factory spec</ion-col>
                    <ion-col class="ion-text-center">Current</ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>Amp 1</ion-col>
                    <ion-col class="ion-text-center">{{ diagnostics.a1?.factorySpec ?? 'N/A' }} A</ion-col>
                    <ion-col class="ion-text-center">{{ diagnostics.a1?.value ?? '—' }} A</ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>Amp 2</ion-col>
                    <ion-col class="ion-text-center">{{ diagnostics.a2?.factorySpec ?? 'N/A' }} A</ion-col>
                    <ion-col class="ion-text-center">{{ diagnostics.a2?.value ?? '—' }} A</ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>Amp 3</ion-col>
                    <ion-col class="ion-text-center">{{ diagnostics.a3?.factorySpec ?? 'N/A' }} A</ion-col>
                    <ion-col class="ion-text-center">{{ diagnostics.a3?.value ?? '—' }} A</ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </ion-accordion>

            <ion-accordion value="performance">
              <ion-item slot="header" lines="full">
                <ion-label>Performance estimates</ion-label>
              </ion-item>
              <div slot="content">
                <ion-list lines="full" class="ion-no-margin">
                  <ion-item>
                    <ion-label class="ion-text-wrap">
                      <h2>Wattage drop <i>((spec − current) / spec)</i></h2>
                      <p>{{ wattageDropDisplay }}</p>
                    </ion-label>
                  </ion-item>

                  <ion-item>
                    <ion-label class="ion-text-wrap">
                      <h2>Estimated max temperature</h2>
                      <p>{{ diagnostics.maxTempEstimate || 'N/A' }}</p>
                    </ion-label>
                  </ion-item>
                </ion-list>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-card>
      </ion-col>
    </ion-row>
  </ng-container>
</ion-grid>
